import FeaturedProfileBanner from './FeaturedProfileBanner';
export default FeaturedProfileBanner;